import axiosInstance from "../config/axios.config";

export const orgDetailsApi = () => {
  return axiosInstance.get("accounts/org-details/");
};
export const updateOrgDetailsApi = (payload) => {
  return axiosInstance.patch("accounts/update-org/", payload);
};
